import type { PlayerStanding } from '@/draw/types';

/**
 * Short display form used by the celebration charts and result rows.
 *
 * A personal name collapses to its last space-separated token (the surname);
 * a team label is free text and must be shown whole — "FC Thunder Cats" is not
 * "Cats". Callers decide which one they hold, the string alone can't tell.
 */
export function celebrationShortName(label: string, isTeamLabel: boolean): string {
  if (isTeamLabel) return label;
  return label.split(' ').pop() || label;
}

export type ShortNamed = { shortName?: string };

/** Short name for a standing row; rows without a precomputed one are personal names. */
export function standingShortName(p: Pick<PlayerStanding, 'playerName'> & ShortNamed): string {
  return p.shortName ?? celebrationShortName(p.playerName, false);
}

/** Stamp `shortName` on each standing row, whole for team-labelled players. */
export function withShortNames<T extends { playerId: string; playerName: string }>(
  rows: readonly T[],
  isTeamLabel: (playerId: string) => boolean,
): (T & { shortName: string })[] {
  return rows.map((r) => ({
    ...r,
    shortName: celebrationShortName(r.playerName, isTeamLabel(r.playerId)),
  }));
}
